




































































































































































































































import { Component } from "vue-property-decorator";
import {
  INVITATION_TYPE,
  TYPE_INVITATION,
} from "@/resources/constants/invitation";

import VueTagsInput from "@johmun/vue-tags-input";
import SelectRoomComponent from "@/app/components/selectRoom/selectRoom.component.vue";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import UserValidator from "@/resources/mixins/userValidator";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import { i18n } from "@/resources/locales";
import { INVITATION_LANGUAGES } from "@/resources/constants/invitationLanguages";
import moment from "moment";
import { URL_CHECK } from "@/resources/constants/urlCheck";
import InvitationFormEducation from "@/app/components/manageSpace/components/users/inviteUsers/invitationFormEducation.component.vue";
@Component({
  name: "invitation-form-component",
  components: {
    SelectRoomComponent,
    VueTagsInput,
    InvitationFormEducation,
  },
})
export default class InvitationFormComponent extends mixins(
  NotificationEvent,
  UserValidator
) {
  LANGUAGES = INVITATION_LANGUAGES;
  language = i18n.locale;
  invitationType = TYPE_INVITATION.NONE;
  TYPE_INVITATION = TYPE_INVITATION;
  email = "";
  emails = [];
  roomSelectedId = -1;
  roomSelected: RoomInterface | null = null;
  loadingGenerate = false;
  loadingSend = false;
  activeRoomSelector = false;
  generate = false;
  hasOnboarding = true;
  alwaysGrazing = false;
  userDescription = i18n
    .t("manageSpaces.inviteUsers.userDescription")
    .toString()
    .split(".");
  guestDescription = i18n
    .t("manageSpaces.inviteUsers.guestDescription")
    .toString()
    .split(".");
  expirationTime = moment().subtract(-2, "days").format("YYYY-MM-DDThh:mm");
  min = moment().format("YYYY-MM-DDThh:mm");
  isTeams = false;
  hawkings = false;
  created(): void {
    let space = this.loadSpace();
    this.isTeams = space.superSpace.isTeams;
    this.$store.dispatch("SpaceStore/getSpaceAction", {
      spaceId: space.id,
      callback: () => {},
    });
    if (space && space.superSpace && space.superSpace.company == "HAWKINGS")
      this.hawkings = true;
    if (this.hawkings) this.invitationSelected = TYPE_INVITATION.EDUCATION;
  }
  get invitationSelected() {
    return this.invitationType;
  }
  set invitationSelected(e) {
    this.invitationType = e;
  }
  updateInvitationSelected(e) {
    this.invitationType = e;
  }
  get url(): string | null {
    let space = this.loadSpace();
    let url = space.guestInvitationToken
      ? window.location.origin +
        (this.invitationType === TYPE_INVITATION.GUEST
          ? `/invitation/guest/${space.guestInvitationToken}`
          : `/invitation/user/${space.userInvitationToken}`) +
        "/" +
        space.name.replaceAll(/[^a-z0-9]+/gi, "_") +
        `?spaceId=${space.id}&hasOnboarding=${this.hasOnboarding}` +
        (this.invitationType === TYPE_INVITATION.USER
          ? `&expirationTime=${this.expirationTime}`
          : "") +
        (this.roomSelectedId >= 0
          ? `&room=${
              this.roomSelected ? this.roomSelected.id : null
            }&alwaysGrazing=${this.alwaysGrazing}`
          : "")
      : null;

    return this.checkUrl(url);
  }
  selectRoom(e): void {
    this.roomSelectedId = e.position;
    this.roomSelected = e.room;
    this.copy();
  }
  addEmail(newEmail): void {
    const regEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const auxEmail = [];

    for (const emails of newEmail) {
      emails.text.replace(" ", ",");
      const caseEmail = emails.text.split(",");
      for (const email of caseEmail) {
        if (regEmail.test(email) && auxEmail.indexOf(email) < 0) {
          auxEmail.push({
            text: email,
            tiClasses: ["ti-valid"],
          });
        }
      }
    }
    this.emails = auxEmail;
  }
  generateUrl(): void {
    this.loadingGenerate = true;
    if (this.invitationType === TYPE_INVITATION.USER) {
      this.$store.dispatch("SpaceStore/generateUserInvitationSpaceAction", {
        spaceId: this.loadSpace().id,
        callback: (data) => {
          this.loadingGenerate = false;
          this.copy();
        },
        callbackError: () => {
          this.loadingGenerate = false;
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t("notifications.errorMessages.invitationExpired")
          );
        },
      });
    } else {
      this.$store.dispatch("SpaceStore/generateInvitationSpaceAction", {
        spaceId: this.loadSpace().id,
        callback: (data) => {
          this.loadingGenerate = false;
        },
        callbackError: () => {
          this.loadingGenerate = false;
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t("notifications.errorMessages.invitationExpired")
          );
        },
      });
    }
  }
  copy(): void {
    const p = document.getElementById("url");
    const cb = navigator.clipboard;
    cb.writeText(p.innerText).then(() =>
      this.onDefault("", this.$i18n.t("notifications.descriptions.copyUrl"))
    );
  }

  sendInvitations(): void {
    const emails = this.emails.map((a) => a.text);
    this.loadingSend = true;
    this.$store.dispatch("UserStore/sendInvitationsAction", {
      data: {
        space: this.loadSpace().id,
        type:
          this.invitationType === TYPE_INVITATION.USER
            ? INVITATION_TYPE.TARGET_USER_INVITATION
            : INVITATION_TYPE.TARGET_GUEST_INVITATION,
        room: this.roomSelectedId >= 0 ? this.roomSelected.id : null,
        hasOnboarding: this.hasOnboarding,
        alwaysGrazing: this.alwaysGrazing,
        language: this.language,
        expirationTime: moment(this.expirationTime)
          .utc()
          .format("yyyy-MM-DD HH:mm:ss"),
        domain: this.checkDomain(),
        emails,
      },
      callback: (response) => {
        this.loadingSend = false;
        this.roomSelectedId = -1;
        if (response.status == "KO") {
          response.message.forEach((element) => {
            const error = element.split(":");
            this.onWarning(
              "",
              error[0] + " " + this.getTextError(error[1]),
              "none"
            );
          });
        }
        if (response.status == "OK") {
          this.emails = [];
          this.hasOnboarding = true;
          this.hasOnboarding = false;
          this.onSuccess(
            this.$i18n.t("notifications.titles.success"),
            this.$i18n.t("notifications.descriptions.sendInvitations")
          );
        }
      },
      callbackError: (error) => {
        this.loadingSend = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
  getTextError(text: string): string {
    //Todo Cambiar cuando se manden las traduciones desde la api.
    const a = "This user already belong to this space";
    const b = "Guest users are not allowed to use user invitation";
    if (text.includes("Guest"))
      return this.$i18n
        .t("notifications.warningMessages.emailErrorGuest")
        .toString();
    if (text.includes("already"))
      return this.$i18n
        .t("notifications.warningMessages.emailInSpace")
        .toString();
  }
  checkUrl(url: string): string {
    if (url && url.includes("https://app.nubii.us")) {
      url = url.replace("https://app.nubii.us", "https://app.nubi.city");
    }
    return url;
  }
  checkDomain(): string {
    URL_CHECK.forEach((element) => {
      if (window.location.host.includes(element.url)) {
        return element.domain;
      }
    });
    return "DEFAULT";
  }
  loadSpace() {
    let space = this.$store.getters["SpaceStore/getSpace"];
    let selectedSapceCustomize =
      this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (selectedSapceCustomize) {
      space = selectedSapceCustomize;
    }
    return space;
  }
}
